/**
 * Хук видимости модуля. Возвращает `true` если:
 *  - модуль есть в `ModulesContext` и `enabled === true`;
 *  - модуль ОТСУТСТВУЕТ в контексте (данные ещё не загружены, аноним,
 *    или провайдер вообще не подключён — например, в unit-тестах
 *    компонентов) — default-visible.
 *
 * `false` — если модуль явно выключен супер-админом: флаги приходят и
 * обычным пользователям через `/api/public/modules` (US-09 FR-1.4).
 */
import { useContext } from 'react';

import { ModulesContext } from '../contexts/ModulesContext';

export const useModulePresent = (moduleId: string): boolean => {
  const ctx = useContext(ModulesContext);
  if (!ctx) return true; // нет провайдера → default-visible
  const entry = ctx.modules.get(moduleId);
  if (entry === undefined) return true;
  return entry.enabled;
};
